class MMProductStickyBlock {
  constructor() {
    this.stickyBlock = document.querySelector('.mm-psb__container');
    this.targetElement = document.querySelector('.mm-product__q-btn-wrapper');
    
    if (!this.stickyBlock || !this.targetElement) {
      return;
    }

    this.stickyBlock.style.opacity = '0';
    this.stickyBlock.style.pointerEvents = 'none';
    this.stickyBlock.style.transition = 'opacity 0.3s ease-in-out';

    this.init();
  }

  init() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.hideStickyBlock();
        } else {
          this.showStickyBlock();
        }
      });
    }, options);

    this.observer.observe(this.targetElement);
  }

  showStickyBlock() {
    this.stickyBlock.style.opacity = '1';
    this.stickyBlock.style.pointerEvents = 'auto';
  }

  hideStickyBlock() {
    this.stickyBlock.style.opacity = '0';
    this.stickyBlock.style.pointerEvents = 'none';
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MMProductStickyBlock();
  });
} else {
  new MMProductStickyBlock();
}

